var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookWave(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 646 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "book_wave",
    style: {
      mixBlendMode: "lighten"
    },
    filter: "url(#filter0_bd)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.5 1044C248.262 918 15.4998 994.259 43 809C70.8855 621.146 377.5 522.418 377.5 395C377.5 247.5 587 291.5 447.926 113.5C308.852 -64.5001 533 -45.4994 627 -193.5C733.015 -360.419 759.849 -247.85 857.936 -155.343C906.836 -109.225 960.204 -56.2585 1007.26 -6.09815C1059.72 49.8291 1102.44 83.7458 1147.24 153.058C1227.73 277.57 1175.7 600.096 1161 777.741C1147.14 945.186 1009.22 1030.42 906.347 1101.34C815.118 1164.23 286.5 1197.5 265.5 1044Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M265.5 1044C248.262 918 15.4998 994.259 43 809C70.8855 621.146 377.5 522.418 377.5 395C377.5 247.5 587 291.5 447.926 113.5C308.852 -64.5001 533 -45.4994 627 -193.5C733.015 -360.419 759.849 -247.85 857.936 -155.343C906.836 -109.225 960.204 -56.2585 1007.26 -6.09815C1059.72 49.8291 1102.44 83.7458 1147.24 153.058C1227.73 277.57 1175.7 600.096 1161 777.741C1147.14 945.186 1009.22 1030.42 906.347 1101.34C815.118 1164.23 286.5 1197.5 265.5 1044Z",
    stroke: "url(#paint1_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bd",
    x: 0.287694,
    y: -333.405,
    width: 1252.24,
    height: 1548.56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_backgroundBlur",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 443.5,
    y1: 41.5001,
    x2: 626,
    y2: 811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE268",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE268",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 251,
    y1: 1009,
    x2: 448,
    y2: 69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6E186"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.042305,
    stopColor: "#F4DF85",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14264,
    stopColor: "#F3DE85",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.265114,
    stopColor: "#E9D685"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.833058,
    stopColor: "#FFE268"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookWave);
export default __webpack_public_path__ + "static/media/book_wave.5af88804.svg";
export { ForwardRef as ReactComponent };